/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserPortfolioQueryVariables = {||};
export type UserPortfolioQueryResponse = {|
  +userPortfolio: ?{|
    +marketCurrentTotal: ?number,
    +percentageDiff: ?number,
    +invested: ?number,
    +profitLoss: ?number,
  |}
|};
export type UserPortfolioQuery = {|
  variables: UserPortfolioQueryVariables,
  response: UserPortfolioQueryResponse,
|};
*/


/*
query UserPortfolioQuery {
  userPortfolio {
    marketCurrentTotal
    percentageDiff
    invested
    profitLoss
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PortfolioNode",
    "kind": "LinkedField",
    "name": "userPortfolio",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketCurrentTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentageDiff",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invested",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profitLoss",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPortfolioQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserPortfolioQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e18390e5ae81b048d72e873a16a23a6a",
    "id": null,
    "metadata": {},
    "name": "UserPortfolioQuery",
    "operationKind": "query",
    "text": "query UserPortfolioQuery {\n  userPortfolio {\n    marketCurrentTotal\n    percentageDiff\n    invested\n    profitLoss\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5b6bd366aa2ef300060b92c74f04ceee';

module.exports = node;
